import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function TestimonialsCTASection() {
  const navigate = useNavigate();

  const handleStartJourney = () => {
    navigate('/supplementation');
  };

  const handleShareStory = () => {
    // This would open a form or contact page for sharing testimonials
    navigate('/donate');
  };

  return (
    <section 
      className="py-20 relative"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/8b27b3a8394e4d9eb0fe507355205670.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-[#111111]/70"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center text-white">
        <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
          Your Success Story Starts Here
        </h2>
        
        <p className="text-xl md:text-2xl mb-12 max-w-4xl mx-auto leading-relaxed opacity-90">
          Join hundreds of patients who have transformed their health with our oxygen solutions. 
          Your journey to better health is just one step away.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <Button
            variant="primary"
            size="lg"
            className="bg-[#12B6B6] hover:bg-[#0ea5a5] shadow-lg hover:shadow-xl px-12"
            onClick={handleStartJourney}
          >
            Start Your Journey
          </Button>
          <Button
            variant="secondary"
            size="lg"
            className="bg-white text-[#111111] hover:bg-gray-100 shadow-lg hover:shadow-xl px-12"
            onClick={handleShareStory}
          >
            Share Your Story
          </Button>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-white/10 rounded-2xl flex items-center justify-center">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-semibold mb-2">Clinically Tested</h3>
            <p className="text-sm opacity-80">Our solutions are backed by scientific research and clinical trials</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-white/10 rounded-2xl flex items-center justify-center">
              <i className="ri-award-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-semibold mb-2">Award Winning</h3>
            <p className="text-sm opacity-80">Recognized for innovation in healthcare and patient outcomes</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-white/10 rounded-2xl flex items-center justify-center">
              <i className="ri-customer-service-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-semibold mb-2">Expert Support</h3>
            <p className="text-sm opacity-80">Dedicated healthcare professionals guide your treatment journey</p>
          </div>
        </div>
      </div>
    </section>
  );
}